import React from 'react';
import styled from 'styled-components';

export const InfoDisclaimers = ({ categories }) => {
  const isBaby = categories?.includes('BABY');
  const isAlcohol = categories?.includes('ALCOHOLIC_BEVERAGES');

  if (isBaby) {
    return (
      <div>
        <Text>
          O Ministério da Saúde informa: O aleitamento materno evita infecções e alergias e é recomendado até os 2
          (dois) anos de idade ou mais. Após os 6 (seis) meses de idade continue amamentando seu filho e ofereça novos
          alimentos.
        </Text>
      </div>
    );
  }

  if (isAlcohol) {
    return (
      <div>
        <Text>É proibida a venda e consumo de bebidas alcoólicas para menores de 18 anos.</Text>
        <Text>Beba com moderação. Se beber não dirija.</Text>
      </div>
    );
  }

  return null;
};

const Text = styled.p`
  padding-bottom: 15px;
  font-size: 14px;
  word-break: break-word;
  font-style: italic;
  color: #666;
  font-family: Helvetica Neue, Helvetica, Arial, Sans-Serif;
`;

export default InfoDisclaimers;
